module.exports = __webpack_public_path__ + "img/arrow-inactive.57082fd0.svg";